import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryPrepareCancelTimeText = async (params: object) => {
  return await GET({ url: Api.queryPrepareCancelTimeText, params, showError: false })
}

export const queryCourierStatus = async (params: object) => {
  return await GET({ url: Api.queryCourierStatus, params, showError: false })
}
